import NomaBanner, {
  NOMA_BANNER_HEADLINE, NOMA_BANNER_TAGLINE, NOMA_CARD_OFFER, NOMA_BRAND_ICON, NOMA_LEARN_MORE_TEXT,
  NOMA_LEARN_MORE_LINK,
} from './NomaBanner';

export {
  NOMA_BANNER_HEADLINE, NOMA_BANNER_TAGLINE, NOMA_CARD_OFFER, NOMA_BRAND_ICON, NOMA_LEARN_MORE_TEXT,
  NOMA_LEARN_MORE_LINK,
};

export default NomaBanner;
